import { render, staticRenderFns } from "./ManutenzioneRichieste.vue?vue&type=template&id=b99afc02&scoped=true&"
import script from "./ManutenzioneRichieste.vue?vue&type=script&lang=js&"
export * from "./ManutenzioneRichieste.vue?vue&type=script&lang=js&"
import style0 from "./ManutenzioneRichieste.vue?vue&type=style&index=0&id=b99afc02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99afc02",
  null
  
)

export default component.exports